export const FEATURE_NAMESPACE = 'feature.tasks'
